import { render } from "./HandleError.vue?vue&type=template&id=f99c415e&scoped=true"
import script from "./HandleError.vue?vue&type=script&lang=js"
export * from "./HandleError.vue?vue&type=script&lang=js"

import "./HandleError.vue?vue&type=style&index=0&id=f99c415e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f99c415e"]])

export default __exports__